var _rect, _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicatesIis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.9648C11.5 8.29961 15.3117 4.5 20 4.5C24.6883 4.5 28.5 8.29961 28.5 12.9648C28.5 17.6301 24.6883 21.4297 20 21.4297C15.3117 21.4297 11.5 17.6301 11.5 12.9648ZM9.15782 28.1379L8.80227 27.7864L9.15782 28.1379C11.529 25.7397 14.668 24.4219 18 24.4219H22C25.3321 24.4219 28.471 25.7397 30.8422 28.1379C33.2023 30.5249 34.5 33.6723 34.5 37.0039C34.5 37.276 34.278 37.5 34 37.5H6C5.72203 37.5 5.5 37.276 5.5 37.0039C5.5 33.6723 6.79773 30.5249 9.15782 28.1379Z",
    fill: "url(#paint0_linear_24786_52062)",
    stroke: "url(#paint1_radial_24786_52062)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_24786_52062)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6086 30.5789H44.2859V27.5851C44.2859 26.1596 43.1429 25 41.7379 25H34.2616C32.8566 25 31.7136 26.1596 31.7136 27.5851V30.5789H24.3909C22.5255 30.5789 21.0079 32.1188 21.0079 34.0114L21.0079 35.6164L21.0079 51.5676C21.0079 53.4602 22.5255 55 24.391 55H51.6086C53.474 55 54.9916 53.4602 54.9916 51.5676L54.9915 35.6384L54.9915 34.0114C54.9916 32.1188 53.474 30.5789 51.6086 30.5789ZM33.9861 27.3056C33.913 27.3798 33.8719 27.4803 33.8718 27.5851V30.5789H42.1277V27.5851C42.1276 27.4803 42.0865 27.3798 42.0134 27.3056C41.9403 27.2315 41.8413 27.1898 41.7379 27.1897H34.2616C34.1583 27.1898 34.0592 27.2315 33.9861 27.3056Z",
    fill: "url(#paint2_linear_24786_52062)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6086 30.5789H44.2859V27.5851C44.2859 26.1596 43.1429 25 41.7379 25H34.2616C32.8566 25 31.7136 26.1596 31.7136 27.5851V30.5789H24.3909C22.5255 30.5789 21.0079 32.1188 21.0079 34.0114L21.0079 35.6164L21.0079 51.5676C21.0079 53.4602 22.5255 55 24.391 55H51.6086C53.474 55 54.9916 53.4602 54.9916 51.5676L54.9915 35.6384L54.9915 34.0114C54.9916 32.1188 53.474 30.5789 51.6086 30.5789ZM33.9861 27.3056C33.913 27.3798 33.8719 27.4803 33.8718 27.5851V30.5789H42.1277V27.5851C42.1276 27.4803 42.0865 27.3798 42.0134 27.3056C41.9403 27.2315 41.8413 27.1898 41.7379 27.1897H34.2616C34.1583 27.1898 34.0592 27.2315 33.9861 27.3056Z",
    fill: "url(#paint3_radial_24786_52062)",
    fillOpacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_24786_52062)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8253 37.5453C50.1577 38.0923 50.0017 38.8167 49.4768 39.1631L38.174 46.6235C37.8301 46.8505 37.3822 46.8433 37.0458 46.6054L26.4934 39.1428C25.9793 38.7792 25.8453 38.0501 26.1942 37.5143C26.5431 36.9785 27.2427 36.8388 27.7568 37.2024L37.0883 43.8017C37.4248 44.0396 37.8727 44.0468 38.2166 43.8198L48.2729 37.1821C48.7978 36.8356 49.4928 36.9982 49.8253 37.5453Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_24786_52062",
    x: 13.0078,
    y: 17,
    width: 49.9834,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24786_52062"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24786_52062",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_24786_52062",
    x: 26,
    y: 37,
    width: 25,
    height: 10.7889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24786_52062"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24786_52062",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24786_52062",
    x1: 5,
    y1: 4,
    x2: 23.2296,
    y2: 36.1699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_24786_52062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.07692 -12.3462) rotate(58.8036) scale(38.9833 37.022)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24786_52062",
    x1: 21,
    y1: 25,
    x2: 34.8487,
    y2: 56.3903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_24786_52062",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21 25) scale(34 30)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicatesIis);
export default __webpack_public_path__ + "static/media/duplicatesIIS.e1eac2cc0149d50170a9f008c38b02f2.svg";
export { ForwardRef as ReactComponent };